import { useAuthStore, hostRole } from '@sentinel/web-core';
import {
  createRootRoute,
  createRoute,
  lazyRouteComponent,
  Outlet,
  redirect,
} from '@tanstack/react-router';
import { AppShell } from '@/shell/AppShell';
import { AccessDeniedPage, NotFoundPage } from '@/shell/ErrorPages';

export const rootRoute = createRootRoute({ component: Outlet, notFoundComponent: NotFoundPage });

/** The authenticated shell: every route below needs a signed-in person. */
export const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'app',
  component: AppShell,
  beforeLoad: () => {
    const role = hostRole();
    const signedIn = useAuthStore.getState().status === 'authenticated';
    // Three hosts (ADR 0013): `accounts.` shows no app, the apps sign in through it.
    if (role === 'accounts') throw redirect({ to: signedIn ? '/handoff' : '/login' });
    if (!signedIn) throw redirect({ to: role === 'single' ? '/login' : '/auth/start' });
  },
});

export const platformRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/platform',
  component: lazyRouteComponent(
    () => import('@/modules/platform/PlatformHomePage'),
    'PlatformHomePage',
  ),
  // The console page speaks only to console sessions: from an organization or a support
  // window the way back is «Torna alla console» in the user menu.
  beforeLoad: () => {
    if (useAuthStore.getState().me?.context !== 'console') throw redirect({ to: '/' });
  },
});

export const deniedRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/denied',
  component: AccessDeniedPage,
});
